/** The venue finder: Google Places results for a typed venue (GET /api/places). */
import { getJson, qs } from "./request";
import type { VenuePlace } from "./types";

export interface Place extends VenuePlace {
  name: string;
  address: string;
}
export const searchPlaces = async (q: string) =>
  (await getJson<{ places: Place[] }>(`/api/places${qs({ q: q.trim() })}`, "Could not search Google Maps")).places;
